module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card', {
    attrs: {
      "basis": _vm.basis,
      "no-border": "",
      "card": _vm.card,
      "value": _vm.value,
      "horizontal": _vm.horizontal
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fc29bc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.common/ui/cards/policy.vue
// module id = 344
// module chunks = 0